import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { CheckCircle } from 'lucide-react';

export default function ActivityRegistrationConfirmPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <Card className="max-w-md w-full">
        <CardContent className="pt-6 text-center">
          <CheckCircle className="h-16 w-16 text-green-600 mx-auto mb-4" />
          <h1 className="text-2xl font-bold mb-2">Registrazione Completata!</h1>
          <p className="text-gray-600 mb-6">
            Ti sei registrato con successo all&apos;evento. Riceverai una conferma via email con tutti i dettagli.
          </p>
          <Button onClick={() => navigate('/')} className="w-full">
            Torna alla Home
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
